// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1TEUt","error":"Textarea_error__jA8aF","readonly":"Textarea_readonly__ggm_O","disabled":"Textarea_disabled__Pt7mr"};